import Services from "@/components/waylio/Services";

export default function ServicesPage() {
  return (
    <main className="pt-10 md:pt-12">
      <Services />
    </main>
  );
}
